export class InternalServerError extends Error {
  constructor() {
    super('Erro no servidor interno')
    this.name = 'InternalServerError'
  }
}
